import { AutogenLayoutTractorQuickInfo } from "./autogen/AutogenLayoutTractorQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class TractorQuickInfo extends AutogenLayoutTractorQuickInfo {
    sourceTractorAfterExecution(event: DataSourceExecutionEvent) {
        this.panelDriver2.visible = !this.activeRow?.isNull("driver2_id");
    }
}
